/**
 * Promo banner click handling.
 *
 * Two jobs on click:
 *  1. Fire a PostHog "promo_banner_clicked" event (named event → funnel-able;
 *     phCapture is the global helper in theme.liquid and no-ops without PostHog).
 *  2. If a discount code is set, apply it to the cart via POST /cart/update.js —
 *     the same AJAX endpoint the cart drawer uses (assets/cart-drawer-discount.js) — then
 *     navigate to the banner's destination. This avoids the native /discount/ URL,
 *     which the local dev server 401s on and which forces a full-page redirect.
 *
 * With no discount code the banner is a plain link: we let the browser navigate
 * normally (PostHog still beacons the click). If the fetch fails we navigate
 * anyway so a network hiccup never traps the click.
 */
(function () {
  function bind(link) {
    if (!link || link.dataset.phReady) return;
    link.dataset.phReady = 'true';

    link.addEventListener('click', function (event) {
      const code = (link.dataset.discountCode || '').trim();

      if (typeof window.phCapture === 'function') {
        window.phCapture('promo_banner_clicked', {
          campaign: link.dataset.campaign || '',
          discount_code: code,
          destination: link.getAttribute('href') || '',
        });
      }

      if (!code || link.dataset.applying) return;

      event.preventDefault();
      link.dataset.applying = 'true';

      const href = link.getAttribute('href') || '/';
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      })
        .catch(function () {
          /* network hiccup — navigate anyway, code just won't be pre-applied */
        })
        .finally(function () {
          window.location.assign(href);
        });
    });
  }

  function bindAll(root) {
    (root || document).querySelectorAll('.promo-banner__link').forEach(bind);
  }

  bindAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target);
  });
})();
